import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import config from "../../../config/config";
import ModulesStep from "../steps/ModulesStep"; // ModulesStep bileşenini import edin
import CustomerStep from "../steps/CustomerStep"; // CustomerStep bileşenini import edin
import {
  Box,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Button,
  CircularProgress,
  Typography,
  IconButton,
  Paper,
  Stack,
  Checkbox,
  Card,
  CardContent,
  Grid,
  Divider,
  InputAdornment,
  createTheme,
  ThemeProvider,
  useTheme,
  Alert,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";
import PackageIcon from "@mui/icons-material/Inventory2";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PeopleIcon from "@mui/icons-material/People";
import CloudIcon from "@mui/icons-material/Cloud";
import ExtensionIcon from "@mui/icons-material/Extension";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import CategoryIcon from "@mui/icons-material/Category";
import StorageIcon from "@mui/icons-material/Storage";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import "./OrderForm.css";
import { useAuth } from "../../login/AuthContext";
import { toast } from "react-toastify";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ArchiveIcon from "@mui/icons-material/Archive";
import DescriptionIcon from "@mui/icons-material/Description";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import TableChartIcon from "@mui/icons-material/TableChart"; // Excel ikonu
import ArticleIcon from "@mui/icons-material/Article"; // Word ikonu
import ImageIcon from "@mui/icons-material/Image"; // Resim ikonu
import DownloadIcon from "@mui/icons-material/Download";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useNavigate, useParams } from "react-router-dom";
import { isPaketEtkin } from "../../../utils/paketEtkin";

const OrderForm = () => {
  const { id } = useParams();
  const { musteriId } = useParams();
  const [extendUntilEnd, setExtendUntilEnd] = useState(false);
  const [extendOneYear, setExtendOneYear] = useState(false);
  const orderId = id || null;

  const isEditMode = Boolean(orderId);

  const { userData, token, hasPermission } = useAuth();

  const [customer, setCustomer] = useState({});
  const [licenses, setLicenses] = useState([]);
  const [selectedLicense, setSelectedLicense] = useState(null);
  const [licenseLoading, setLicenseLoading] = useState(false);

  const [packageInfo, setPackageInfo] = useState({
    type: "",
    startDate: "",
    endDate: "",
    userCount: 1,
    licenseType: "",
    serverType: "",
  });

  const minUserCount = 1;
  const [maxUserCount, setMaxUserCount] = useState(1);

  const [selectedModules, setSelectedModules] = useState([]);
  // const [isNewCustomer, setIsNewCustomer] = useState(false);
  const [customerFiles, setCustomerFiles] = useState([]);
  const [packagesDetails, setPackagesDetails] = useState([]);
  const aktifPaketler = packagesDetails.filter(
    (p) => isPaketEtkin(p) || p.PaketAdi === packageInfo.type,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const prevPackageTypeRef = useRef("");

  // İlk olarak state'i existing olarak başlat
  const [licenseOption, setLicenseOption] = useState("existing");

  // Lisanslar değiştiğinde otomatik seçim yapacak useEffect
  useEffect(() => {
    if (!isEditMode) {
      // Sadece yeni kayıt modunda çalışsın
      if (licenses.length === 0) {
        setLicenseOption("new");
      } else {
        setLicenseOption("existing");
      }
    }
  }, [licenses, isEditMode]);

  // LicenseOptions komponentini güncelle
  const LicenseOptions = () => (
    <FormControl component="fieldset" sx={{ mb: 0.5 }}>
      <Typography variant="subtitle1" sx={{ mb: 0.5, fontWeight:"600", color:"text.secondary" }}>Lisans Seçeneği</Typography>
      <RadioGroup
        row
        value={licenseOption}
        onChange={(e) => setLicenseOption(e.target.value)}
        sx={{ gap: 2,  fontSize: "calc(1.7vh * 0.9)"}}
      >
        <FormControlLabel
          value="existing"
          control={<Radio disabled={isDisabled || licenses.length === 0} />}
          label={`Mevcut Lisans ${
            licenses.length === 0 ? "(Lisans Bulunamadı)" : ""
          }`}
          disabled={isDisabled || licenses.length === 0}
        />
        <FormControlLabel
          value="new"
          control={<Radio disabled={isDisabled} />}
          label="Yeni Lisans"
          disabled={isDisabled}
        />
      </RadioGroup>
    </FormControl>
  );

  const fetchPackages = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${config.baseURL}/paketler/paket-detay-list`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!response.data || response.data.length === 0) {
        throw new Error("Paketler alınamadı veya boş.");
      }

      setPackagesDetails(response.data);
    } catch (error) {
      console.error("Paketler alınamadı:", error);
      toast.error(
        "Paketler yüklenirken hata oluştu. Lütfen daha sonra tekrar deneyiniz."
      );
    } finally {
      setIsLoading(false);
    }
  };
  const fetchCustomerPackage = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${config.baseURL}/musteriler/paket/${musteriId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data && response.data.Id) {
        setPackageInfo((prevState) => ({
          ...prevState,
          type: response.data.Adi || "",
          packageId: response.data.Id || "",
          startDate: new Date().toISOString().split("T")[0],
          userCount: 1,
          licenseType: "Yıllık",
          serverType: "Bulut Sunucu",
        }));
      }
    } catch (error) {
      console.error("Müşteri paketi alınamadı:", error);
      toast.error("Müşteri paketi alınamadı");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchLicenses = useCallback(
    async (musteriNo) => {
      if (!musteriNo) return;
      setLicenseLoading(true);
      try {
        const response = await axios.get(
          `${config.baseURL}/lisanslar/musteri-lisans/aktif-musteri-no/${musteriNo}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setLicenses(response.data || []);
      } catch (error) {
        console.error("Lisans bilgileri alınamadı:", error);
        toast.error("Lisans bilgileri yüklenirken hata oluştu");
      } finally {
        setLicenseLoading(false);
      }
    },
    [token]
  );

  const fetchOrderDetails = async () => {
    try {
      const res = await axios.get(`${config.baseURL}/siparis/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res || !res.data) {
       navigate("/404", { replace: true });;
        throw new Error("API'den geçersiz yanıt alındı.");
      }

      const orderDetails = res.data;
      setLicenseOption(orderDetails.isNewLicense ? "new" : "existing");
      setIsDisabled(orderDetails.DurumAd === "Onaylandı");
      setExtendUntilEnd(orderDetails.extendUntilEnd);
      setExtendOneYear(orderDetails.extendOneYear);

      setCustomer({
        customer: {
          MusteriNo: orderDetails.MusteriNo,
          Tel: orderDetails.Tel || "",
          Tel2: orderDetails.Tel2 || "",
          Unvan: orderDetails.Unvan || "",
          VergiDairesi: orderDetails.VergiDairesi || "",
          VergiNo: orderDetails.VergiNo || "",
          TCKimlikNo: orderDetails.TCKimlikNo || "", // TCKimlikNo eklendi
          Yetkili: orderDetails.Yetkili || "",
          EPosta: orderDetails.EPosta || "",
          Il: orderDetails.Il || "", // Il eklendi
          Ilce: orderDetails.Ilce || "", // Ilce eklendi
          Adres: orderDetails.Adres || "",
          DurumAd: orderDetails.DurumAd || "",
          Aciklama: orderDetails.Aciklama || "",
          RedSebebi: orderDetails.RedSebebi || "",
          BayiKodu: userData.BayiKodu || "", // BayiKodu eklendi
        },
      });
      // Fetch licenses if customer number exists
      if (orderDetails.MusteriNo) {
        await fetchLicenses(orderDetails.MusteriNo);

        // Find and set matching license after licenses are loaded
        if (orderDetails.UserNo) {
          const licenseResponse = await axios.get(
            `${config.baseURL}/lisanslar/musteri-lisans/aktif-musteri-no/${orderDetails.MusteriNo}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );

          const matchingLicense = licenseResponse.data?.find(
            (lic) => String(lic.UserNo) === String(orderDetails.UserNo)
          );

          if (matchingLicense) {
            setSelectedLicense(matchingLicense.Id);
          }
        }
      }

      // Paket satırı: EkModul false veya 0; modül satırları: EkModul true veya 1 (DB BIT 0/1 gelebilir)
      const paketHareketi = orderDetails.Hareketler?.find(
        (h) => h.EkModul === false || h.EkModul === 0
      );
      const modulHareketleri =
        orderDetails.Hareketler?.filter(
          (h) => h.EkModul === true || h.EkModul === 1
        ) || [];

      setPackageInfo({
        type: paketHareketi?.PaketAdi || "",
        startDate: orderDetails.LisansBaslangicTarihi || "",
        endDate: orderDetails.LisansBitisTarihi || "",
        userCount: orderDetails.KullaniciSayisi || 1,
        licenseType: orderDetails.LisansTipi,
        serverType: (orderDetails.SunucuTipi || "").trim() || "Yerel Sunucu",
        packageId: paketHareketi?.ProgramId ?? "",
      });

      setSelectedModules(
        modulHareketleri.map((h) => ({
          id: h.id ?? h.ProgramId,
          ProgramId: h.ProgramId ?? h.id,
          name: h.name ?? "",
          EkModul: true,
        }))
      );

      const files = orderDetails.Dokumanlar?.map((doc) => ({
        dokumanId: doc.Id,
        name: doc.DosyaAdi,
        systemName: doc.SistemDosyaAdi,
        url: `${config.baseURL}/docs/${doc.SistemDosyaAdi}`,
        type: `application/${doc.DosyaAdi.split(".").pop()}`,
        size: doc.DosyaBoyutu,
      }));
      setCustomerFiles(files || []);
    } catch (error) {
      console.error("Error fetching order details:", error);
      // toast.error("Sipariş detayları alınamadı.");
      navigate("/404", { replace: true });;
    }
  };

  useEffect(() => {
    const initializeData = async () => {
      await fetchPackages();
      if (musteriId) {
        await fetchCustomerPackage();
      } else if (isEditMode) {
        await fetchOrderDetails();
      }
    };
    initializeData();
  }, [musteriId, isEditMode]);

  // Fetch licenses when customer changes
  useEffect(() => {
    if (customer?.customer?.MusteriNo) {
      fetchLicenses(customer.customer.MusteriNo);
    }
    return () => {
      setLicenses([]);
      setSelectedLicense(null);
    };
  }, [customer?.customer?.MusteriNo, fetchLicenses]);

  const handleCustomerChange = async (name, value) => {
    if (name === "customer") {
      // Mevcut customer verilerini koru ve yeni verileri ekle
      setCustomer((prevCustomer) => ({
        customer: {
          ...prevCustomer.customer, // Önceki verileri koru
          ...value, // Yeni verileri ekle
          BayiKodu: userData.BayiKodu,
        },
      }));

      if (value.Id) {
        // Var olan müşteri için paket ve modül bilgilerini getir
        try {
          const [packageResponse, modulesResponse] = await Promise.all([
            axios.get(`${config.baseURL}/musteriler/paket/${value.Id}`, {
              headers: { Authorization: `Bearer ${token}` },
            }),
            axios.get(`${config.baseURL}/musteriler/ekmodule/${value.Id}`, {
              headers: { Authorization: `Bearer ${token}` },
            }),
          ]);

          setSelectedLicense(null);

          if (packageResponse.data && packageResponse.data.Id) {
            setPackageInfo({
              type: packageResponse.data.Adi || "",
              packageId: packageResponse.data.Id || "",
              startDate: new Date().toISOString().split("T")[0],
              userCount: 1,
              licenseType: "Yıllık",
              serverType: "Bulut Sunucu",
            });
          }

          if (modulesResponse.data) {
            const modules = modulesResponse.data.map((module) => ({
              id: module.Id,
              ProgramId: module.Id,
              name: module.ProgramAdi,
              EkModul: true,
            }));
            setSelectedModules(modules);
          }
        } catch (error) {
          console.error("Müşteri bilgileri yüklenirken hata oluştu:", error);
          toast.error("Müşteri bilgileri yüklenirken hata oluştu");
        }
      }
    } else {
      // Diğer input değişikliklerini ele al
      setCustomer((prevCustomer) => ({
        customer: {
          ...prevCustomer.customer,
          [name]: value,
          BayiKodu: userData.BayiKodu,
        },
      }));
    }
  };

  const handlePackageChange = (e) => {
    const { name, value } = e.target;

    // Paket bilgilerini güncelle
    setPackageInfo((prevPackageInfo) => {
      const updatedPackageInfo = {
        ...prevPackageInfo,
        [name]: value, // name: type, licenseType, startDate vb.
      };

      // Başlangıç tarihi kontrolü
      const startDate =
        updatedPackageInfo.startDate &&
        !isNaN(new Date(updatedPackageInfo.startDate))
          ? new Date(updatedPackageInfo.startDate) // Geçerli bir tarih varsa kullan
          : new Date(); // Aksi halde bugünün tarihi

      const licenseType = updatedPackageInfo.licenseType;
      let endDate = null;

      // Lisans tipi ve başlangıç tarihi hesaplama
      if (licenseType) {
        switch (licenseType) {
          case "Yıllık":
            endDate = new Date(startDate);
            endDate.setFullYear(startDate.getFullYear() + 1); // 1 yıl ekle
            break;
          case "Ömür Boyu":
            endDate = new Date("2038-01-01"); // Sabit tarih
            break;
          case "Demo":
            endDate = new Date(startDate);
            endDate.setMonth(startDate.getMonth() + 1); // 1 ay ekle
            break;
          default:
            endDate = null;
        }
      }

      return {
        ...updatedPackageInfo,
        endDate: endDate ? endDate.toISOString().split("T")[0] : "", // ISO formatında tarih
      };
    });

    // Paket türü kullanıcı tarafından değiştiğinde ek modülleri sıfırla
    if (name === "type") {
      setSelectedModules([]);
      prevPackageTypeRef.current = value || "";
      const selectedPackageDetails = packagesDetails.find(
        (paket) => paket.PaketAdi === value
      );

      if (selectedPackageDetails) {
        const maxUsers = selectedPackageDetails.MaxKullaniciSayisi || 1;
        setMaxUserCount(maxUsers);

        setPackageInfo((prevState) => ({
          ...prevState,
          packageId: selectedPackageDetails.PaketId,
          userCount: Math.min(prevState.userCount || 1, maxUsers),
        }));
      }
    }
  };

  // Paket listesi / tipi senkronu: packageId ve max kullanıcıyı güncelle.
  // packagesDetails geç gelince seçili ek modülleri SİLME.
  // Modül temizleme yalnızca handlePackageChange(name === "type") içinde yapılır.
  useEffect(() => {
    if (!packageInfo.type || packagesDetails.length === 0) return;

    const selectedPackageDetails = packagesDetails.find(
      (paket) => paket.PaketAdi === packageInfo.type
    );

    if (!selectedPackageDetails) return;

    const maxUsers = selectedPackageDetails.MaxKullaniciSayisi || 1;
    setMaxUserCount(maxUsers);
    prevPackageTypeRef.current = packageInfo.type;

    setPackageInfo((prevState) => {
      const nextUserCount = Math.min(prevState.userCount || 1, maxUsers);
      if (
        prevState.packageId === selectedPackageDetails.PaketId &&
        prevState.userCount === nextUserCount
      ) {
        return prevState;
      }
      return {
        ...prevState,
        packageId: selectedPackageDetails.PaketId,
        userCount: nextUserCount,
      };
    });
  }, [packageInfo.type, packagesDetails]);

  const handleModuleChange = (name, modules) => {
    setSelectedModules(modules);
  };

  const MAX_FILE_SIZE_MB = 10;

  const handleFileChange = (event) => {
    // FileList'ten dosyaları alıyoruz
    const selectedFiles = Array.from(event.target.files);

    // Maksimum dosya boyutu kontrolü
    const validFiles = [];
    for (const file of selectedFiles) {
      if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
        toast.error("Maksimum dosya boyutu 10MB olmalıdır.");
        continue;
      }
      validFiles.push(file);
    }

    // Dosyaları customerFiles dizisine ekliyoruz
    setCustomerFiles((prevFiles) => [...prevFiles, ...validFiles]);

    // Eğer geçici URL oluşturmak istiyorsanız (önizleme için), aşağıdaki şekilde de yapılabilir:
    const previewFiles = validFiles.map((file) => ({
      name: file.name,
      type: file.type,
      size: (file.size / 1024).toFixed(2) + " KB",
      url: URL.createObjectURL(file), // Geçici URL oluşturuyoruz
    }));

    // Eğer sadece dosya ismi, boyutu gibi bilgileri göstermek istiyorsanız:
  };

  const [filesToDelete, setFilesToDelete] = useState([]);

  const handleRemoveFile = (index, dokumanId) => {
    // Eğer backend'den gelen dosya ise (dokumanId varsa) isDeleted olarak işaretle
    if (dokumanId) {
      setFilesToDelete((prev) => [...prev, dokumanId]);
      setCustomerFiles((prevFiles) =>
        prevFiles.map((file, i) =>
          i === index ? { ...file, isDeleted: true } : file
        )
      );
    } else {
      // Yeni yüklenen dosya ise direkt listeden kaldır
      setCustomerFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    }
  };

  const [downloadingFiles, setDownloadingFiles] = useState([]);

  const handleDownloadFile = async (fileName) => {
    setDownloadingFiles((prev) => [...prev, fileName]);
    const fileUrl = `${config.baseURL}/siparis/download/${fileName}`;
    try {
      const response = await fetch(fileUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) throw new Error("Dosya indirilemedi.");
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Dosya indirilemedi.");
    } finally {
      setDownloadingFiles((prev) => prev.filter((f) => f !== fileName));
    }
  };

  const getFileIcon = (type = "") => {
    if (type.includes("pdf")) return <PictureAsPdfIcon color="error" />;
    if (type.includes("zip")) return <ArchiveIcon color="primary" />;
    if (type.includes("xlsx") || type.includes("spreadsheet"))
      return <TableChartIcon color="success" />; // Excel
    if (type.includes("xml")) return <DescriptionIcon color="info" />;
    if (type.includes("docs")) return <ArticleIcon color="info" />; // Word
    if (type.includes("png") || type.includes("jpg") || type.includes("jpeg"))
      return <ImageIcon color="warning" />; // Resim
    return <InsertDriveFileIcon color="disabled" />;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const formData = new FormData();
      const selectedLic = licenses.find((lic) => lic.Id === selectedLicense);

      // Package verilerini hazırla
      const packageData = {
        ...packageInfo,
        LisansId: selectedLicense,
        isNewLicense: licenseOption === "new",
        UserNo: selectedLic?.UserNo || "",
        extendUntilEnd: licenseOption === "existing" ? extendUntilEnd : false,
        extendOneYear: licenseOption === "existing" ? extendOneYear : false,
      };

      // Debug için konsola yazdır
      // console.log('Package Data:', packageData);

      // Form verilerini ekle
      formData.append("customer", JSON.stringify(customer.customer));
      formData.append("package", JSON.stringify(packageData));
      formData.append("selectedModules", JSON.stringify(selectedModules));

      // Debug için form verilerini kontrol et
      // for (let pair of formData.entries()) {
      //   console.log(pair[0], pair[1]);
      // }

      // Yardımcı validasyon fonksiyonları
      function isEmpty(value) {
        return !value || value.toString().trim() === "";
      }

      // E-posta doğrulama (basit versiyon)
      function isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      }

      // Sadece sayılardan oluşan uzunluk kontrolü
      function isDigits(value, length) {
        return new RegExp(`^\\d{${length}}$`).test(value);
      }

      // GSM numarası kontrolü (Tel için)
      function isValidGSM(phone) {
        // 05xxxxxxxxx formatı (GSM)
        return /^(\+90|0)?[5][0-9]{9}$/.test(phone.replace(/\s+/g, ""));
      }

      // Sabit hat veya GSM kontrolü (Tel2 için)
      function isValidPhoneOrLandline(phone) {
        const cleanPhone = phone.replace(/\s+/g, "");
        // GSM: 05xxxxxxxxx
        const gsmPattern = /^(\+90|0)?[5][0-9]{9}$/;
        // Sabit hat: 02xx, 03xx, 04xx serisi (7 haneli)
        const landlinePattern = /^(\+90|0)?[2-4][0-9]{2}[0-9]{7}$/;

        return gsmPattern.test(cleanPhone) || landlinePattern.test(cleanPhone);
      }

      // TC Kimlik No algoritma kontrolü
      function isValidTCKimlik(tcNo) {
        if (tcNo.length !== 11) return false;

        const digits = tcNo.split("").map(Number);

        // İlk hane 0 olamaz
        if (digits[0] === 0) return false;

        // 10. hane kontrolü
        const oddSum =
          digits[0] + digits[2] + digits[4] + digits[6] + digits[8];
        const evenSum = digits[1] + digits[3] + digits[5] + digits[7];
        const checkDigit10 = (oddSum * 7 - evenSum) % 10;

        if (checkDigit10 !== digits[9]) return false;

        // 11. hane kontrolü
        const totalSum = digits
          .slice(0, 10)
          .reduce((sum, digit) => sum + digit, 0);
        const checkDigit11 = totalSum % 10;

        return checkDigit11 === digits[10];
      }

      // Validasyonlar - Tüm hataları topla
      const validationErrors = [];

      // Ünvan kontrolü
      if (isEmpty(customer?.customer?.Unvan)) {
        validationErrors.push("Müşteri ünvan bilgilerini doldurun.");
      }

      // Tel kontrolü (sadece GSM)
      if (!isEmpty(customer?.customer?.Tel) && !isValidGSM(customer?.customer?.Tel)) {
        validationErrors.push("Tel alanı geçerli bir GSM numarası olmalıdır (örn: 05xxxxxxxxx).");
      }

      // Tel2 kontrolü (sabit hat veya GSM)
      if (!isEmpty(customer?.customer?.Tel2) && !isValidPhoneOrLandline(customer?.customer?.Tel2)) {
        validationErrors.push("Tel2 alanı geçerli bir telefon numarası olmalıdır (GSM: 05xxxxxxxxx veya Sabit: 02xxxxxxx).");
      }

      // Telefon kontrolleri - en az bir tanesi geçerli olmalı
      const hasValidPhone =
        (!isEmpty(customer?.customer?.Tel) &&
          isValidGSM(customer?.customer?.Tel)) ||
        (!isEmpty(customer?.customer?.Tel2) &&
          isValidPhoneOrLandline(customer?.customer?.Tel2));

      if (!hasValidPhone) {
        if (
          isEmpty(customer?.customer?.Tel) &&
          isEmpty(customer?.customer?.Tel2)
        ) {
          validationErrors.push("En az bir telefon numarası giriniz.");
        } else {
          validationErrors.push(
            "Geçerli bir telefon numarası giriniz (örn: 05xxxxxxxxx)."
          );
        }
      }

      // Vergi dairesi kontrolü
      if (isEmpty(customer?.customer?.VergiDairesi)) {
        validationErrors.push("Vergi dairesi bilgisini giriniz.");
      }

      // E-posta kontrolü
      if (isEmpty(customer?.customer?.EPosta)) {
        validationErrors.push("Email adresi bilgisini giriniz.");
      } else if (!isValidEmail(customer?.customer?.EPosta)) {
        validationErrors.push("Geçerli bir email adresi giriniz.");
      }

      // İl kontrolü
      if (isEmpty(customer?.customer?.Il)) {
        validationErrors.push("İl bilgisini giriniz.");
      }

      // İlçe kontrolü
      if (isEmpty(customer?.customer?.Ilce)) {
        validationErrors.push("İlçe bilgisini giriniz.");
      }

      // Adres kontrolü
      if (isEmpty(customer?.customer?.Adres)) {
        validationErrors.push("Adres bilgisini giriniz.");
      }

      // Vergi/TC kontrolleri - gelişmiş
      if (
        isEmpty(customer?.customer?.VergiNo) &&
        isEmpty(customer?.customer?.TCKimlikNo)
      ) {
        validationErrors.push(
          "Vergi Numarası ya da TC Kimlik No alanı dolu olmalıdır."
        );
      } else {
        // Vergi No kontrolü
        if (!isEmpty(customer?.customer?.VergiNo)) {
          if (!isDigits(customer?.customer?.VergiNo, 10)) {
            validationErrors.push("Vergi Numarası 10 haneli sayı olmalıdır.");
          }
        }

        // TC Kimlik No kontrolü
        if (!isEmpty(customer?.customer?.TCKimlikNo)) {
          if (!isDigits(customer?.customer?.TCKimlikNo, 11)) {
            validationErrors.push(
              "TC Kimlik Numarası 11 haneli sayı olmalıdır."
            );
          } else if (!isValidTCKimlik(customer?.customer?.TCKimlikNo)) {
            validationErrors.push("Geçerli bir TC Kimlik Numarası giriniz.");
          }
        }
      }

      // Eğer hata varsa göster ve işlemi durdur
      if (validationErrors.length > 0) {
        // İlk hatayı toast ile göster
        toast.warning(validationErrors[0]);

        return;
      }

      // Validasyon başarılı, işleme devam et...

      // Dosya işlemleri
      if (customerFiles?.length > 0) {
        const invalidFiles = customerFiles.filter(
          (file) => file instanceof File && file.type !== "application/pdf"
        );
        if (invalidFiles.length > 0) {
          toast.error("Yalnızca PDF dosyaları yüklenebilir.");
          return;
        }
        customerFiles.forEach((file) => {
          if (file instanceof File) {
            formData.append("customerFiles", file);
          }
        });
      }

      const endpoint = `${config.baseURL}/siparis/${isEditMode ? orderId : ""}`;
      const response = await axios({
        method: isEditMode ? "put" : "post",
        url: endpoint,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      // Response'u kontrol et
      // console.log('Response:', response.data);

      // Dosya silme işlemleri
      if (filesToDelete.length > 0) {
        await Promise.all(
          filesToDelete.map((dokumanId) =>
            fetch(`${config.baseURL}/siparis/delete-file/${dokumanId}`, {
              method: "DELETE",
              headers: { Authorization: `Bearer ${token}` },
            })
          )
        );
      }

      toast.success(
        isEditMode ? "Sipariş güncellendi." : "Sipariş oluşturuldu."
      );
      navigate("/siparisler");
    } catch (error) {
      console.error("Form gönderimi hatası:", error);

      // Detaylı hata bilgisi
      if (error.response) {
        console.error("Error Response:", error.response.data);

        // 400 hatası (Bad Request) - Validasyon hataları
        if (error.response.status === 400) {
          const responseData = error.response.data;

          // Backend'den gelen yapılandırılmış hata
          if (
            responseData.errors &&
            Array.isArray(responseData.errors) &&
            responseData.errors.length > 0
          ) {
            toast.warning(responseData.errors[0]); // İlk validasyon hatasını göster
          }
          // Backend'den gelen basit string hata
          else if (typeof responseData === "string") {
            toast.warning(responseData);
          }
          // Backend'den gelen message içinde hata
          else if (responseData.message) {
            toast.warning(responseData.message);
          }
          // Fallback
          else {
            toast.warning("Lütfen form bilgilerini kontrol ediniz.");
          }
        }
        // Diğer HTTP hataları
        else {
          const errorMessage =
            error.response.data?.message ||
            error.response.data ||
            `Sunucu hatası (${error.response.status})`;
          toast.error(errorMessage);
        }
      }
      // Network hatası vs
      else {
        toast.error("Bağlantı hatası. Lütfen tekrar deneyiniz.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const navigate = useNavigate();
  const outerTheme = useTheme();

  const customTheme = (outerTheme) =>
    createTheme({
      palette: {
        ...outerTheme.palette,
        mode: outerTheme.palette.mode,
      },
      typography: {
        ...outerTheme.typography,
      },
      components: {
        MuiTextField: {
          styleOverrides: {
            root: {
              "--TextField-brandBorderColor": outerTheme.palette.mode === 'dark' ? '#424242' : '#D0D0D0',
              "--TextField-brandBorderHoverColor": outerTheme.palette.mode === 'dark' ? '#616161' : '#9E9E9E',
              "--TextField-brandBorderFocusedColor": outerTheme.palette.mode === 'dark' ? '#757575' : '#616161',
              "& label.Mui-focused": {
                color: "var(--TextField-brandBorderFocusedColor)",
              },
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            notchedOutline: {
              borderColor: "var(--TextField-brandBorderColor)",
            },
            root: {
              [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
                borderColor: "var(--TextField-brandBorderHoverColor)",
              },
              [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
                borderColor: "var(--TextField-brandBorderFocusedColor)",
              },
              "& input": {
                fontSize: "calc(1.7vh * 0.9)", // ~15.3px (1.7vh * 0.9)
              },
              "& textarea": {
                fontSize: "calc(1.7vh * 0.9)", // ~15.3px (1.7vh * 0.9)
              },
            },
          },
        },
        MuiSelect: {
          styleOverrides: {
            root: {
              "& .MuiSelect-select": {
                fontSize: "calc(1.7vh * 0.9)", // ~15.3px (1.7vh * 0.9)
              },
            },
          },
        },
        MuiMenuItem: {
          styleOverrides: {
            root: {
              fontSize: "calc(1.9vh * 0.9)", // ~15.3px (1.7vh * 0.9)
            },
          },
        },
        MuiFormControlLabel: {
          styleOverrides: {
            root: {
              fontSize: "calc(1.7vh * 0.9)", // ~15.3px (1.7vh * 0.9)
              "& .MuiFormControlLabel-label": {
                fontSize: "calc(1.7vh * 0.9)", // ~15.3px (1.7vh * 0.9)
              },
            },
          },
        },
        MuiRadio: {
          styleOverrides: {
            root: {
              fontSize: "calc(1.7vh * 0.9)", // ~15.3px (1.7vh * 0.9)
            },
          },
        },
        MuiCard: {
          styleOverrides: {
            root: {
              boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
              borderRadius: "8px",
              border: `1px solid ${outerTheme.palette.mode === 'dark' ? '#424242' : '#E0E0E0'}`,
              transition: "none",
            },
          },
        },
      },
    });

  const SectionHeader = ({ icon: Icon, title }) => (
    <Box display="flex" alignItems="center" gap={1.5} mb={2}>
      <Icon
        sx={{
          color: outerTheme.palette.mode === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.54)',
          fontSize: '1.25rem'
        }}
      />
      <Typography
        variant="subtitle2"
        fontWeight={600}
        sx={{
          color: outerTheme.palette.mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
          textTransform: 'uppercase',
          fontSize: '0.75rem'
        }}
      >
        {title}
      </Typography>
    </Box>
  );

  const handleCancel = () => {
    setCustomer({ id: "", name: "", phone: "", email: "" });
    setPackageInfo({
      type: "",
      startDate: "",
      endDate: "",
      userCount: 1,
      licenseType: "",
      serverType: "",
    });
    setSelectedModules([]);
    // setIsNewCustomer(false);
    setCustomerFiles(null);

    // React Router ile yönlendirme
    navigate("/siparisler");
  };
  function formatFileSize(sizeInBytes) {
    if (sizeInBytes < 1024) {
      return `${sizeInBytes} B`;
    } else if (sizeInBytes < 1024 * 1024) {
      return `${(sizeInBytes / 1024).toFixed(2)} KB`;
    } else {
      return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
    }
  }

  const [selectedStatus, setSelectedStatus] = useState("");

  useEffect(() => {
    if (customer?.customer?.DurumAd) {
      setSelectedStatus(customer.customer.DurumAd);
    }
  }, [customer]);

  const handleStatusChange = (e) => {
    const newStatus = e.target.value; // Yeni durum

    // Durum ID'sini al (Örnek getDurumIdFromAd fonksiyonu ile)
    const updatedDurum = getDurumIdFromAd(newStatus);

    // Durum ve DurumAd'ı güncelle
    setCustomer((prevCustomer) => {
      const updatedCustomer = {
        customer: {
          ...prevCustomer.customer, // Müşteri verilerini koruyun
          DurumAd: newStatus,
          Durum: updatedDurum, // Durum adı burada da geçerli
        },
      };
      return updatedCustomer; // Güncellenmiş müşteri verisini döndürün
    });
  };

  const getDurumIdFromAd = (durumAd) => {
    switch (durumAd) {
      case "Onay Bekliyor":
        return 1;
      case "Onaylandı":
        return 2;
      case "Reddedildi":
        return 6;
      case "Tamamlandı":
        return 4;
      default:
        return 0; // Varsayılan olarak "Bilinmeyen Durum"
    }
  };

  const handleReasonChange = (e) => {
    const { name, value } = e.target;
    setCustomer((prevCustomer) => ({
      customer: {
        ...prevCustomer.customer, // Müşteri verilerini koruyun
        [name]: value, // Durum adı burada da geçerli
      },
    }));
  };

  const [pdfLoading, setPdfLoading] = useState(false);

  // OrderForm component içine eklenecek yeni fonksiyon
  const handleDownloadPDF = async () => {
    try {
      setPdfLoading(true); // PDF indirme başladığında loading durumunu aktif et

      const customerDetails = {
        companyName: customer?.customer?.Unvan,
        taxNumber: customer?.customer?.VergiNo,
        taxOffice: customer?.customer?.VergiDairesi,
        phone: customer?.customer?.Tel,
        email: customer?.customer?.EPosta,
        address: customer?.customer?.Adres,
      };

      const licenseDetails = {
        licenseType: packageInfo?.licenseType,
        serverType: packageInfo?.serverType,
        userCount: packageInfo?.userCount,
        startDate: packageInfo?.startDate,
        endDate: packageInfo?.endDate,
      };

      const response = await axios.post(
        `${config.baseURL}/siparis/pdf/preview`,
        {
          customerDetails,
          licenseDetails,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob", // PDF formatında cevap almak için
        }
      );

      // PDF dosyasını indir
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      // Format date for filename to be consistent (e.g., "2025-01-09")
      const fileName = `Lisans_Sozlesmesi_${
        new Date().toISOString().split("T")[0]
      }.pdf`;

      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      // Notify user of success
      toast.success("PDF başarıyla indirildi!");
    } catch (error) {
      console.error("PDF indirme hatası:", error);
      toast.error("PDF indirilirken bir hata oluştu");
    } finally {
      setPdfLoading(false); // PDF indirme işlemi tamamlandığında loading durumu kapanır
    }
  };

  const handleLicenseChange = (event) => {
    const licenseId = event.target.value;
    const selectedLic = licenses.find((lic) => lic.Id === licenseId);

    setSelectedLicense(licenseId);

    if (selectedLic) {
      setPackageInfo((prev) => ({
        ...prev,
        userCount: selectedLic.UserCount,
        licenseType: selectedLic.LisansTipi,
        startDate: selectedLic.BitisTarih,
        serverType: selectedLic.SunucuTipi || prev.serverType,
        isNewLicense: licenseOption === "new",
      }));
    }
  };

  return (
    <ThemeProvider theme={customTheme(outerTheme)}>
      <div className="cari-listesi-container">
        <Box sx={{ width: {
        xs: '95%',
        sm: '90%',
        md: '80%',
        lg: '70%'
      }, mx: 'auto', p: 3 }}>
          <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>
            {isEditMode ? "Sipariş Düzenle" : "Sipariş Ekle"}
          </Typography>
          {isDisabled && (
            <Alert
              severity="warning"
              sx={{
                mb: 2,
                borderRadius: 1,
                '& .MuiAlert-icon': {
                  alignItems: 'center'
                }
              }}
            >
              Onaylanmış belgede düzenleme yapamazsınız!
            </Alert>
          )}
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            {/* Customer Information Section */}
            <CustomerStep
              onChange={handleCustomerChange}
              initialData={customer}
              orderId={orderId}
              isDisabled={isDisabled}
              isEditMode={isEditMode}
              customer={customer}
            />

            {/* Package Information Section */}
            <Card elevation={0} sx={{ my: 1.5 }}>
              <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <SectionHeader icon={PackageIcon} title="Paket Bilgileri" />
                <Divider sx={{ mb: 2, mt: 0.5 }} />
                <Grid container spacing={2}>
                  <Grid item xs={12} sx={{ mb:0.5}}>
                    <FormControl fullWidth>
                      <InputLabel>Paket Tipi</InputLabel>
                      <Select
                        name="type"
                        value={packageInfo.type}
                        onChange={handlePackageChange}
                        required
                        label="Paket Tipi"
                        disabled={isDisabled}
                        renderValue={(value) => (
                          <Box display="flex" alignItems="center" gap={1}>
                            <PackageIcon color="action" fontSize="small" />
                            <span>{value || "Paket Seçiniz"}</span>
                          </Box>
                        )}
                      >
                        <MenuItem value="" disabled>Paket Seçiniz</MenuItem>
                        {aktifPaketler.map((paket) => (
                          <MenuItem key={paket.PaketId} value={paket.PaketAdi}>
                            {paket.PaketAdi}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {customer?.customer?.MusteriNo && (
                    <>
                      <Grid item xs={12} >
                        <LicenseOptions />
                      </Grid>
                      {licenseOption === "existing" && (
                        <Grid item xs={12} sx={{ my: 1 }}>
                          <FormControl fullWidth>
                            <InputLabel>Lisans</InputLabel>
                            <Select
                              value={selectedLicense || ""}
                              onChange={handleLicenseChange}
                              label="Lisans"
                              disabled={isDisabled || licenseLoading}
                              required
                              renderValue={(value) => {
                                if (!value) {
                                  return (
                                    <Box display="flex" alignItems="center" gap={1}>
                                      <VpnKeyIcon color="action" fontSize="small" />
                                      <span>{licenseLoading ? "Yükleniyor..." : "Lisans Seçiniz"}</span>
                                    </Box>
                                  );
                                }
                                const selectedLicenseData = licenses.find(l => l.Id === value);
                                const displayText = selectedLicenseData
                                  ? `ClientId - ${selectedLicenseData.UserNo} - Bitiş Tarihi - ${selectedLicenseData.BitisTarih ? new Date(selectedLicenseData.BitisTarih).toLocaleDateString("tr-TR") : "Tarih Yok"}`
                                  : "Lisans Seçiniz";
                                return (
                                  <Box display="flex" alignItems="center" gap={1}>
                                    <VpnKeyIcon color="action" fontSize="small" />
                                    <span>{displayText}</span>
                                  </Box>
                                );
                              }}
                            >
                              <MenuItem value="" disabled>
                                {licenseLoading ? "Yükleniyor..." : "Lisans Seçiniz"}
                              </MenuItem>
                              {licenses.map((license) => {
                                const bitisTarih = license.BitisTarih
                                  ? new Date(license.BitisTarih).toLocaleDateString(
                                      "tr-TR"
                                    )
                                  : "Tarih Yok";

                                return (
                                  <MenuItem key={license.Id} value={license.Id}>
                                    ClientId - {license.UserNo} - Bitiş Tarihi -{" "}
                                    {bitisTarih}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>
                      )}
                    </>
                  )}
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Lisans Başlangıç Tarihi"
                      type="date"
                      name="startDate"
                      disabled={isDisabled}
                      value={
                        packageInfo.startDate
                          ? new Date(packageInfo.startDate).toISOString().split("T")[0]
                          : ""
                      }
                      onChange={handlePackageChange}
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CalendarTodayIcon color="action" fontSize="small" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Kullanıcı Sayısı"
                      type="number"
                      name="userCount"
                      value={packageInfo.userCount}
                      onChange={handlePackageChange}
                      inputProps={{
                        min: minUserCount,
                        max: maxUserCount,
                      }}
                      helperText={`* Seçili pakette maksimum ${maxUserCount} kullanıcı alınabilir.`}
                      required
                      disabled={isDisabled || !packageInfo.type}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PeopleIcon color="action" fontSize="small" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel>Lisans Tipi</InputLabel>
                      <Select
                        name="licenseType"
                        value={packageInfo.licenseType}
                        onChange={handlePackageChange}
                        required
                        label="Lisans Tipi"
                        disabled={isDisabled}
                        renderValue={(value) => (
                          <Box display="flex" alignItems="center" gap={1}>
                            <CategoryIcon color="action" fontSize="small" />
                            <span>{value || "Lisans Tipi Seçiniz"}</span>
                          </Box>
                        )}
                      >
                        <MenuItem value="" disabled>Lisans Tipi Seçiniz</MenuItem>
                        <MenuItem value="Yıllık">Yıllık</MenuItem>
                        <MenuItem value="Demo">Demo</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel>Sunucu Tipi</InputLabel>
                      <Select
                        name="serverType"
                        value={packageInfo.serverType}
                        onChange={handlePackageChange}
                        required
                        label="Sunucu Tipi"
                        disabled={isDisabled}
                        renderValue={(value) => (
                          <Box display="flex" alignItems="center" gap={1}>
                            <StorageIcon color="action" fontSize="small" />
                            <span>{value || "Sunucu Tipi Seçiniz"}</span>
                          </Box>
                        )}
                      >
                        <MenuItem value="" disabled>Sunucu Tipi Seçiniz</MenuItem>
                        <MenuItem value="Bulut Sunucu">Bulut Sunucu</MenuItem>
                        <MenuItem value="Yerel Sunucu">Yerel Sunucu</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {licenseOption === "existing" &&
                    packageInfo.licenseType === "Yıllık" &&
                    selectedLicense && (
                      <Grid item xs={12}>
                        <Box>
                          <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight:"600", color:"text.secondary"}}>
                            Lisans Uzatma Seçenekleri:
                          </Typography>
                          <Stack spacing={1} fontSize={"calc(1.7vh * 0.9)"}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={extendUntilEnd}
                                  onChange={(e) => {
                                    setExtendUntilEnd(e.target.checked);
                                    if (e.target.checked) {
                                      setExtendOneYear(false);
                                    }
                                  }}
                                  disabled={isDisabled}
                                  color="primary"
                                />
                              }
                              label="Mevcut lisans bitiş tarihine kadar uzat"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={extendOneYear}
                                  onChange={(e) => {
                                    setExtendOneYear(e.target.checked);
                                    if (e.target.checked) {
                                      setExtendUntilEnd(false);
                                    }
                                  }}
                                  disabled={isDisabled}
                                  color="primary"
                                />
                              }
                              label="Lisans bitiş tarihinden 1 yıl sonrasına kadar uzat"
                            />
                          </Stack>
                          <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontStyle: 'italic' }}>
                            Not: Hiçbir seçenek seçilmediğinde lisans belirttiğiniz tarihten itibaren bir yıl uzar
                          </Typography>
                        </Box>
                      </Grid>
                    )}
                </Grid>
              </CardContent>
            </Card>

            {/* Modules Section */}
            <Card elevation={0} sx={{ mb: 1.5 }}>
              <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <SectionHeader icon={ExtensionIcon} title="Ek Modüller" />
                <Divider sx={{ mb: 2, mt: 0.5 }} />
                {packageInfo.type ? (
                  <ModulesStep
                    selectedPackage={packagesDetails.find(
                      (paket) => paket.PaketAdi === packageInfo.type
                    )}
                    selectedModules={selectedModules}
                    onChange={handleModuleChange}
                    isDisabled={isDisabled}
                  />
                ) : (
                  <Typography color="textSecondary">
                    Lütfen bir paket seçiniz.
                  </Typography>
                )}
              </CardContent>
            </Card>

            {/* File Upload Section */}
            <Card elevation={0} sx={{ mb: 1.5 }}>
              <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <SectionHeader icon={AttachFileIcon} title="Müşteri Dosyası" />
                <Divider sx={{ mb: 2, mt: 0.5 }} />

            <Paper elevation={1} sx={{ p: 2 }}>
              {/* File Upload Button */}
              <Box display="flex" alignItems="center" gap={2} mb={2}>
                <Button
                  variant="contained"
                  component="label"
                  startIcon={<UploadFileIcon />}
                  disabled={isDisabled}
                >
                  Dosya Yükle
                  <input
                    type="file"
                    accept="application/pdf" // Sadece PDF dosyalarına izin ver
                    multiple
                    hidden
                    onChange={handleFileChange}
                  />
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleDownloadPDF}
                  disabled={pdfLoading || isDisabled}
                  startIcon={
                    pdfLoading ? (
                      <CircularProgress size={20} />
                    ) : (
                      <FileDownloadIcon />
                    )
                  }
                >
                  {pdfLoading ? "İndiriliyor..." : "PDF İndir"}
                </Button>
              </Box>

              {/* Uploaded Files */}
              <Stack spacing={2}>
                {customerFiles.length > 0 ? (
                  customerFiles.map((file, index) => (
                    <Paper
                      key={index}
                      variant="outlined"
                      className={`file-row ${
                        file.isDeleted ? "file-deleted" : ""
                      }`}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 1,
                      }}
                    >
                      <Box display="flex" alignItems="center" gap={2}>
                        {getFileIcon(file.type)} {/* Dosya türüne göre ikon */}
                        <Box>
                          <Typography variant="body1" sx={{ fontSize: "calc(1.7vh * 0.9)" }}>{file.name}</Typography>
                          <Typography variant="body2" color="text.secondary">
                            {formatFileSize(file.size)}
                          </Typography>
                        </Box>
                      </Box>
                      <Box display="flex" gap={1}>
                        {/* İndirme Butonu */}
                        {isEditMode && (
                          <IconButton
                            color="primary"
                            onClick={() => handleDownloadFile(file.systemName)}
                            disabled={downloadingFiles.includes(file.systemName)}
                          >
                            {downloadingFiles.includes(file.systemName) ? (
                              <CircularProgress size={20} />
                            ) : (
                              <DownloadIcon />
                            )}
                          </IconButton>
                        )}
                        {/* Sil Butonu */}
                        <IconButton
                          color="error"
                          onClick={() =>
                            handleRemoveFile(index, file.dokumanId)
                          }
                          disabled={isDisabled}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    </Paper>
                  ))
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    Henüz bir dosya seçilmedi.
                  </Typography>
                )}
              </Stack>
            </Paper>
              </CardContent>
            </Card>

            <Card elevation={0} sx={{ mb: 1.5 }}>
              <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <SectionHeader icon={DescriptionIcon} title="Açıklama" />
                <Divider sx={{ mb: 2, mt: 0.5 }} />
                <TextField
                  fullWidth
                  label="Açıklama"
                  name="Aciklama"
                  value={customer?.customer?.Aciklama || ""}
                  onChange={handleReasonChange}
                  multiline
                  rows={4}
                  disabled={isDisabled}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" sx={{ alignSelf: "flex-start"}}>
                        <DescriptionIcon color="action" fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                />
              </CardContent>
            </Card>
             {selectedStatus === "Reddedildi" && (
              <Card elevation={0} sx={{ my: 1.5 }}>
                <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                  <SectionHeader icon={DescriptionIcon} title="Red Sebebi" />
                  <Divider sx={{ my: 2, mt: 0.5 }} />
                  <TextField
                    required
                    name="RedSebebi"
                    label="Red Sebebi"
                    variant="outlined"
                    value={customer.customer.RedSebebi}
                    onChange={handleReasonChange}
                    multiline
                    rows={4}
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" sx={{ alignSelf: "flex-start", }}>
                          <DescriptionIcon color="action" fontSize="small" />
                        </InputAdornment>
                    ),
                  }}
                />
                </CardContent>
              </Card>
            )}

          {/* Form Actions */}
          <Box className="form-actions" display="flex" gap={2}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isLoading || isDisabled}
            >
              {isLoading ? (
                <CircularProgress size={24} />
              ) : isEditMode ? (
                "Güncelle"
              ) : (
                "Kaydet"
              )}
            </Button>
            <Button type="button" onClick={handleCancel} variant="outlined">
              Kapat
            </Button>

            {/* Onay Durumu Seç (Sadece Düzenleme Modunda) */}
            {isEditMode && (
              <>
                {hasPermission("admin") && (
                  <FormControl
                    variant="outlined"
                    size="small"
                    sx={{
                      minWidth: 150,
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "primary.main",
                        },
                        "&:hover fieldset": {
                          borderColor: "primary.main",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "primary.main",
                        },
                      },
                    }}
                  >
                    <InputLabel>Onay Durumu</InputLabel>
                    <Select
                      value={selectedStatus}
                      onChange={handleStatusChange}
                      label="Onay Durumu"
                      disabled={isDisabled}
                    >
                      <MenuItem value="Onaylandı">Onaylandı</MenuItem>
                      <MenuItem value="Onay Bekliyor">Onay Bekliyor</MenuItem>
                      <MenuItem value="Reddedildi">Reddedildi</MenuItem>
                    </Select>
                  </FormControl>
                )}
              </>
            )}
          </Box>
            {/* Reddedildi Durumu İçin Açıklama */}

          </form>
        </Box>
      </div>
    </ThemeProvider>
  );
};

export default OrderForm;
